import React from 'react'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import Button from '../common/ui-components/input/Button';
import { useState } from 'react';
import UITextField from '../common/ui-components/input/UITextField';
import UIDropdown from '../common/ui-components/input/UIDropdown/UIDropdown';
import UITextArea from '../common/ui-components/input/UITextArea';
import { PostForm } from '../../api/contact-us/index';
import Image from '../common/Image';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import { useRouter } from 'next/router';
import { validateFiles } from '../../utils/fileHandler';

interface MainProps{
    subIssues: any,
    onClose: any
}


export const QueryForm = (props: MainProps) => {
    const [thanks, setThanks] = useState(false);
    const [email, setEmail] = useState<any>(null);
    const [name, setName] = useState<any>(null);
    const [phone, setPhone] = useState<any>(null);
    const [issue, setIssue] = useState<any>(null);
    const [subIssue, setSubIssue] = useState<any>(null);
    const [comment, setComment] = useState<string>("");
    const [errorIssue, setErrorIssue] = useState<string>("");
    const [errorSubIssue, setErrorSubIssue] = useState("");
    const [issueBorder, setIBorder] = useState<boolean>(true);
    const [subIssueBorder, setSubIBorder] = useState<boolean>(true);
    const [filename, setFilename] = useState<string>("")
    const [fileVal, setFileVal] = useState<boolean>(true)
    const [file, setFile] = useState<Blob | any>()
    const [reqsent, setReqsent] = useState<boolean>(false)
    const [loading] = useState(false);
    const [subIssues, setSubIssues] = React.useState<any>([{
        text: 'Select Sub-Issue',
        value: 'Select Sub-Issue',
        key: 0
    }])

    const router = useRouter()

    const handleSelectPhone = (e) => {
        setPhone(e.target.value)
    }


    const handleSelect = (e) => {
        setErrorIssue("")
        setIBorder(true)
        setIssue(e["value"])
        let b = props.subIssues[e["text"]].map(myfunc)
        setSubIssues(b)
        setSubIssue(null)
        return false
    }

    const handleSelectSubIssue = (e) => {
        setErrorSubIssue("")
        setSubIBorder(true)
        setSubIssue(e["value"])
        return false
    }

    const handleSelectComment = (e) => {
        setComment(e.target.value)
    }

    const handleFile = async (e) => {
        const supported:any = ["jpeg", "jpg", "png", "doc", "docx", "pdf"]
        let validatefile = await validateFiles(e.target.files[0],supported,5120)
        if(validatefile['valid']){
            setFileVal(true)
            setFile(e.target.files[0])
            setFilename(e.target.files[0].name)
        }else{
            setFileVal(false)
        }
        return false;
    }

    const remove = (e) => {
        e.preventDefault()
        setFilename("")
    }

    const validateEmail = (e) => {

        let value = e.target.value.trim();
        if(value !== "") {
            let reg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(!reg.test(String(value).toLowerCase())) {
                setEmail(undefined)
                return false;
            }
        }
    }

    const valPhone = (e) => {

        let value = e.target.value.trim();
        if(value !== "") {
            let reg = /^\d{10}$/
            if(!reg.test(value)) {
                setPhone(undefined)
                return false;
            }
        }
       
    }

    const handleSubmit = (e) => {
        if (!name || !email || !phone || !issue || !subIssue || !email || !phone) {
            if (name === null) {
                setName("")
            }
            if (email === null) {
                setEmail("")
            }
            if (phone === null) {
                setPhone("")
            }
            if (issue === null) {
                setIBorder(false)
                setErrorIssue("Required fields")
            }
            if (subIssue === null) {
                setIBorder(false)
                setErrorSubIssue("Required fields")
            }

            let element = document.getElementById("name");
            if (element)
                window.scrollTo({
                    top: element.getBoundingClientRect().top + window.pageYOffset - 110,
                    behavior: "smooth"
                });
        }
        else {
            e.preventDefault()
            const data = new FormData()
            data.append("name", name)
            data.append("email", email)
            data.append("phone", phone)
            data.append("issue", issue)
            data.append("sub_issue", subIssue)
            data.append("comment", comment)
            data.append("subject", "Query raised via Selfserve")
            if (filename !== "") { data.append("doc", file, filename) }
            if (reqsent === false) {
                PostForm(data)
                setReqsent(true)
            }
            setName("")
            setPhone("")
            setEmail("")
            setComment("")
            setIssue(null)
            setSubIssue(null)
            setFilename("")
            setFile("")
            setThanks(true)
            return false
        }
    }

    const issueOptions: any[] = [
        {
            text: "Get my device repaired",
            value: "Get my device repaired",
            key: 1,
        },
        {
            text: "Know the repair status",
            value: "Know the repair status",
            key: 2,
        },
        {
            text: "Get my registration certificate",
            value: "Get my registration certificate",
            key: 3,
        },
        {
            text: "Purchase a new plan",
            value: "Purchase a new plan",
            key: 4,
        },
        {
            text: "Complain",
            value: "Complain",
            key: 5,
        },
        {
            text: "Know about my refunds",
            value: "Know about my refunds",
            key: 6,
        },
        {
            text: "Appreciate / share feedback",
            value: "Appreciate / share feedback",
            key: 7,
        },
        {
            text: "Plan Related Issue",
            value: "Plan Related Issue",
            key: 8,
        }
    ]

    function myfunc(val) {
        return {
            value: val,
            text: val,
            key: val
        }
    }

    let showing = filename !== "" ? filename : "Choose file .jpg, .jpeg, .png, .doc, .pdf, .docx not more than 5MB"

    let che = filename !== "" ? <label htmlFor="remove" className={`${styles.remove__button}`}>Remove</label> : ""


    return (
        <React.Fragment>
            {thanks ?
                <div className={styles.selfserve_alert}>
                    <h5 className={styles.selfserve_alert__title}>Thank You</h5>
                    <div className={styles.selfserve_alert__text}>
                        <p>We have noted your concern. A query has been raised. An Onsitego representative will get in touch with you soon to help you. The ticket reference number will be emailed to you along with details of the query.</p>
                    </div>
                    <div className={commonStyles.single_button}>
                        <Button
                            onClick={() => { props.onClose(), router.push('/')}}
                            text="Ok"
                            className={commonStyles.single_btn}
                        />

                    </div>
                </div>
                :
                <form method="POST" action="#" className={styles.form_wrap} encType="multipart/form-data">
                    <h6>Write to Us</h6>
                    <div className={styles.input_wrap}>
                        <div className={styles.selfserve_text_area}><UITextField id="name" isForm={true} noLabel={true} className={`${styles.formdiv__textfield}`} type="text" isRequired={true} value={name} label="Full Name" propsError={name || name == null ? '' : 'Enter your name'} onChange={(e) => setName(e.target.value)} /></div>

                        <div className={styles.selfserve_text_area}><UITextField id="email" isForm={true} noLabel={true} className={`${styles.formdiv__textfield}`} type="text" isRequired={true} value={email} label="Email ID" onBlur={validateEmail} propsError={email !== "" || email == null  ? email === undefined ? 'Enter a valid email address' : '' : 'Enter your email id'} onChange={(e) => setEmail(e.target.value.trim())} /></div>

                        <div className={styles.selfserve_text_area}><UITextField id="phone" isForm={true} noLabel={true} className={`${styles.formdiv__textfield}`} type="number" onBlur={valPhone} isRequired={true} value={phone} label="Phone Number" propsError={phone || phone == null ? phone === undefined ? 'Enter a valid phone no' : '' : 'Enter your phone no'} onChange={(e: any) => handleSelectPhone(e)} /></div>

                        <div className={styles.selfserve_dropdown}><UIDropdown isRequired={true} className={issueBorder ? `${styles.bordering}` : `${styles.bordering__error}`} propsError={errorIssue} options={issueOptions} selected_option={issue === null ? null : { text: issue, value: issue, key: issue }} placeholder="Select Issue" onChange={(e: React.ChangeEvent<{}>) => handleSelect(e)} /> </div>

                        <div className={styles.selfserve_dropdown}><UIDropdown isRequired={true} className={subIssueBorder ? `${styles.bordering}` : `${styles.bordering__error}`} propsError={errorSubIssue} options={subIssues} selected_option={subIssue === null ? null : { text: subIssue, value: subIssue, key: subIssue }} placeholder="Select Sub-issue" onChange={(e: React.ChangeEvent<{}>) => handleSelectSubIssue(e)} /> </div>

                        <div className={styles.selfserve_text_area}>
                            <UITextArea noPlaceholder={false} label="Comments" className={`${styles.formdiv__textfield}`} value={comment} onChange={(e: any) => handleSelectComment(e)} />

                        </div>
                        <div className={`${styles.uploadfile_flex}`}>
                            <input id="file_button" type="file" onChange={(e: React.ChangeEvent<{}>) => handleFile(e)} hidden={true} />

                            <div className={`${styles.upload__img}`}>
                                <Image src="/static/images/contactus/computing-cloud.png" alt={"placeholder"} width="40" height="40" />
                            </div>
                            <div className={`${styles.uploadsection}`}><label htmlFor="file_button" className={`${styles.custom_input}`} >Upload File (optional) </label>
                                <button id="remove" hidden={true} onClick={(e: React.ChangeEvent<{}>) => remove(e)}></button>

                                <p className={`${fileVal ? `${styles.upload__help}` : `${styles.upload__error}`} ${filename !== "" ? `${styles.upload__filename}` : ""}`}>{showing}{che}</p>
                            </div>
                        </div>

                        <div className={commonStyles.single_button} style={{'marginTop':'40px'}}>
                            <Button
                                text="Submit"
                                onClick={(e) => { handleSubmit(e) }}
                                loading={loading}
                                className={commonStyles.single_btn}
                                style={{'fontSize': '14px'}}
                            />

                        </div>

                    </div>
                </form>
            }
        </React.Fragment>
    )
}